export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<span class="sr-only" id="' +
((__t = (ctx.id)) == null ? '' : __t) +
'-missing-fields-header">\n  ' +
((__t = ( ctx.t('Empty fields') )) == null ? '' : __t) +
'\n</span>\n<ul class="utrecht-unordered-list openforms-soft-required-errors__missing-fields" aria-labelledby="' +
((__t = (ctx.id)) == null ? '' : __t) +
'-missing-fields-header">\n';
 for (const label of ctx.labels) { ;
__p += '\n  <li class="utrecht-unordered-list__item">' +
((__t = ( label )) == null ? '' : __t) +
'</li>\n';
 } ;
__p += '\n</ul>\n';
return __p
}